import PublicApi from "@/PublicApi";
import type { LanguageTextResponse } from "@/models/LanguageTextResponse";

const endpoint = "language/";

export default {
  getSprachtexte: async () => {
    try {
      const response = await PublicApi.get(endpoint);
      return response.data as LanguageTextResponse;
    } catch (error) {
      console.error("Error fetching sprachtexte:", error); // Handle error appropriately
      return {
        de: null,
        fr: null,
        en: null,
        it: null,
      } as LanguageTextResponse; // Return an empty or default response
    }
  },
};
